export default function createFolderValidation(folderBody) {
  if (!folderBody.name) return true;
  if (!folderBody.is_technical && !folderBody.is_financial && !folderBody.is_internal_only) return true;
}